import debounce from 'lodash/debounce';

export default function trackEvent({ action, label }) {
  dataLayer.push({
    'event': 'event to GA',
    'eventCategory': 'product gallery demo',
    'eventAction': action,
    'eventLabel': label
  });
}

export const debouncedTracker = debounce(trackEvent, 1000);

export const eventNames = {
  primary: 'edit color palette',
  onPrimary: 'edit color palette',
  active: 'edit color palette',
  transition: 'edit fade transition',
  aspectRatio: 'edit aspect ratio',
  moreAspectRatio: 'edit aspect ratio',
  navigation: 'edit navigation',
  zoom: 'edit show zoom',
  zoomProps: {
    type: 'edit zoom type',
    trigger: 'edit zoom trigger',
    viewerPosition: 'edit zoom viewer position'
  },
  carouselLocation: 'edit carousel location',
  carouselOffset: 'edit carousel offset',
  carouselStyle: 'edit carousel style',
  thumbnailProps: {
    width: 'edit carousel thumbnail width',
    height: 'edit carousel thumbnail height',
    navigationShape: 'edit carousel navigation button shape',
    selectedStyle: 'edit carousel selected thumbnail style',
    selectedBorderPosition: 'edit carousel selected thumbnail border position',
    selectedBorderWidth: 'edit carousel selected thumbnail border width',
    mediaSymbolShape: 'edit carousel media symbol shape',
  },
  indicatorProps: {
    shape: 'edit carousel indicator shape'
  },
  labels: {
    zoom: {
      false: 'off',
      true: 'on'
    },
    primary: 'primary',
    onPrimary: 'onPrimary',
    active: 'active'
  }
};
